import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import Search from "antd/es/input/Search";
import {
  CheckOutlined,
  CloseOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button, Col, message, Popconfirm, Row, notification, Space, Table, Form,Tag, Tooltip, Modal, Switch
} from "antd";
import IMAGES from "../../../const/Image";
import { useLocation } from "react-router-dom";
import Search from "antd/es/input/Search";
import { components, getRowClassName } from "../../../utils/utils";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Tabs ,Input} from "antd";
import DashboardRequest from "../DashboardRequest";
import { usePermission } from "../../../hooks/usePermission";

const initialFilter = { page: 1 };
 
function CustomServiceRequest() {

   const hasListPermission = usePermission("CustomServiceRequests", "List");
    // console.log('Has list permission:', hasListPermission);

  const [loading, setLoading] = useState(false);
  const [labList, setLabList] = useState([]);
  const { confirm } = Modal;
  const [form] = Form.useForm();
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
    const [updatedSalons, setUpdatedSalons] = useState([]);
   const location = useLocation();
    const [activeTab, setActiveTab] = useState(location.state?.tabKey || "1");
    const [activeTabUpdate, setActiveTabupdate] = useState(5);

  const navigate = useNavigate();

  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
   render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    // {
    //   title: "Id",
    //   dataIndex: "id",
    //   key: "id",
    // },
    {
      title: "Category Name",
      dataIndex: "saloncategory",
      key: "categoryTitle",
      render: (saloncategory) =>
        saloncategory && saloncategory.category
          ? saloncategory.category.categoryTitle
          : "N/A",

    },
    {
      title: "Salon Name",
      dataIndex: "salon",
      key: "salonName",
      render: (salon) =>
        salon ? `${salon.salonName}` : "N/A",
    },
    {
      title: "Service Name",
      dataIndex: "serviceName",
      key: "serviceName",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      // render: (is_active, item) => (
      //   <Switch
      //     checked={is_active === 1}
      //     checkedChildren="Active"
      //     unCheckedChildren="InActive"
      //     onChange={(checked) => handleStatusChange(checked, item)}
      //   />
      // ),

         render: (is_active) => (
        <Tag color={is_active === 1 ? "green" : "red"}>
          {is_active === 1 ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            <span
              className="action-icon-bg"
              onClick={() => navigate(`/dashboard/custom-service-requet/view/${record.salonId}`)}
            >
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip>

        </Space>
      ),
    },
    // Add other columns as needed
  ];
  const newRequestColumns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    // {
    //   title: "Id",
    //   dataIndex: "id",
    //   key: "id",
    // },
    {
      title: "Category Name",
      dataIndex: "saloncategory",
      key: "categoryTitle",
      render: (saloncategory) =>
        saloncategory && saloncategory.category
          ? saloncategory.category.categoryTitle
          : "N/A",

    },
    {
      title: "Salon Name",
      dataIndex: "salon",
      key: "salonName",
      render: (salon) =>
        salon ? `${salon.salonName}` : "N/A",
    },
    {
      title: "Service Name",
      dataIndex: "serviceName",
      key: "serviceName",
    },

      {
          title: "Approval",
          width: "150px",
          render: (text, record) => (
            <Space>
              {console.log(record?.serviceId, "service Id")}
              <Tooltip
                title={
                  record?.status === "0" || record?.status === "1"
                    ? null
                    : "Reject"
                }
              >
                <Button
                  onClick={() => handleApproved(record?.id, 2)}
                  type="primary"
                  danger
                  shape="circle"
                  disabled={
                    record?.status === "0" || record?.status === "1"
                  }
                  icon={<CloseOutlined />}
                />
              </Tooltip>
              <Tooltip
                title={
                  "Created" === "Created"
                    ? "Verify"
                    : record?.status === "Verified"
                    ? "Approve"
                    : null
                }
              >
                <Button
                  onClick={() => handleApproved(record?.id, 1)}
                  type="primary"
                  shape="circle"
                  className={record?.status === "Verified" ? "success_button" : ""}
                  disabled={
                    record?.status === "0" || record?.status === "1"
                  }
                  icon={<CheckOutlined />}
                />
              </Tooltip>
            </Space>
          ),
        },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      // render: (is_active, item) => (
      //   <Switch
      //     checked={is_active === 1}
      //     checkedChildren="Approved"
      //     unCheckedChildren="Rejected"
      //     onChange={(checked) => handleStatusChange(checked, item)}
      //   />
      // ),
         render: (is_active) => (
        <Tag color={is_active === 1 ? "green" : "red"}>
          {is_active === 1 ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            <span
              className="action-icon-bg"
              onClick={() => navigate(`/dashboard/custom-service-requet/view/${record.salonId}`)}
            >
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip>

        </Space>
      ),
    },
    // Add other columns as needed
  ];

  const fetchServiceList = () => {
    setLoading(true);
    // CategoryRequest.categoryList(searchFilter.page, searchFilter.limit, searchFilter.title)
    const searchFilter = filter.searchTerm;

    DashboardRequest.customerRequestList({...filter, type: activeTab })
      .then((response) => {
        const rawData = response?.data?.data || [];
        console.log("rawdata", rawData)
        const totalCount = response?.data?.pagination?.totalItems || 0;
        // const paginationData = response?.data?.pagination || {}; 
        setLabList(rawData);
        setTotalRecords(totalCount);
          // setTotalRecords(paginationData.totalItems || 0);
        console.log(totalCount , 'totalCount')
      })
      .catch((error) => {
        message.error("Failed to fetch requests.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
 
         if (hasListPermission) {
      fetchServiceList();
    }
  }, [filter , activeTab , hasListPermission]);

   const handleApproved = (id, item) => {
    let reason = "";
    const modal = confirm({
      title: `Are you sure you want to ${
        item === 1 ? "approve" : "reject"
      } this salon?`,
      content: item !== 1 && (
        <div style={{ marginTop: 16 }}>
          <Input.TextArea
            placeholder="Enter reason for the rejection"
            onChange={(e) => {
              reason = e.target.value;
              modal.update({
                okButtonProps: {
                  disabled: !reason.trim(),
                },
              });
            }}
          />
        </div>
      ),
      okText: "Yes",
      okType: "danger",
      okButtonProps: {
        disabled: item !== 1 ? true : false,
      },
      cancelText: "No",
      onOk() {
        setLoading(true);
        DashboardRequest.approveServiceReq({
          id: id,
          isApprove: item,
          rejection_reason: item !== 1 ? reason : undefined,

          // 2 for approved, 3 for rejected
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: `Salon ${
                  item === 1 ? "approved" : "rejected"
                } successfully`,
              });
              fetchServiceList();
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  const handleStatusChange = (checked, item) => {
    confirm({
      title: `Are you sure you want to ${checked ? "activate" : "deactivate"} this service?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        DashboardRequest.UpdateServiceReq({
          id: item.id,
          status: checked ? "1" : "0",
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: "Status updated successfully",
              });
              setLabList((prevList) =>
                prevList.map((el) =>
                  el.id === item.id ? { ...el, status: checked ? 1 : 0 } : el
                )
              );
              // fetchServiceList();
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };


  const onSearch = (searchTerm) => {
    setFilter({
      ...filter,
      searchTerm: searchTerm.toLowerCase(),
      page: 1, 
    });
  };

  //   const handleChangeupdate = (pagination) => {
  //   setFilter((prev) => ({
  //     ...prev,
  //     page: pagination.current, 
  //   }));
  // };

  const handleTabChange = (key) =>{
    setActiveTab(key);
    setFilter(prev =>({
      ...prev, 
      page : 1 
    }))
  }
    const handleChange = (pagination) => {
    setFilter((prev) => ({
      ...prev,
      page: pagination.current,
    }));
  };

    const items = [
      {
        key: "1",
        label: "All Custom Requests",
        children: (
          <div style={{}}>
            <Table
              size="middle"
              bordered
              rowClassName={getRowClassName}
              components={components}
              columns={columns(navigate)}
              loading={loading}
         
              scroll={{ x: "max-content" }}
              onChange={handleChange}
              dataSource={labList || null}
          
  
              pagination={{
                total: totalRecords,
                current: filter?.page, 
                pageSize: 10, 
                showSizeChanger: false, 
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
                onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
              }}
            />
          </div>
        ),
      },
      {
        key: "2",
        label: "New Requests",
        children: (
          <div style={{}}>
            <Table
              size="middle"
              bordered
              rowClassName={getRowClassName}
              components={components}
              columns={newRequestColumns(navigate)}
              loading={loading}
 
              scroll={{ x: "max-content" }}
              onChange={handleChange}
              dataSource={labList || null}
              pagination={{
                total: totalRecords, 
                current: filter?.page, 
                pageSize: 10, 
                showSizeChanger: false, 
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
                onChange: (page) => setFilter((prev) => ({ ...prev, page })), 
              }}
            />
          </div>
        ),
      },
      {
        key: "3",
        label: "Approved Requests",
        children: (
          <div style={{}}>
            <Table
              size="middle"
              bordered
              rowClassName={getRowClassName}
              components={components}
              columns={columns(navigate)}
              loading={loading}
         
              scroll={{ x: "max-content" }}
              onChange={handleChange}
              dataSource={labList || null}
              pagination={{
                total: totalRecords, 
                current: filter?.page,
                pageSize: 10, 
                showSizeChanger: false, 
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
                onChange: (page) => setFilter((prev) => ({ ...prev, page })), 
              }}
            />
          </div>
        ),
      },
      {
        key: "4",
        label: "Rejected Requests",
        children: (
          <div style={{}}>
            <Table
              size="middle"
              bordered
              rowClassName={getRowClassName}
              components={components}
              columns={columns(navigate)}
              loading={loading}

              scroll={{ x: "max-content" }}
              onChange={handleChange}
              dataSource={labList || null}
              pagination={{
                total: totalRecords, 
                current: filter?.page, 
                pageSize: 10,
                showSizeChanger: false,
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
                onChange: (page) => setFilter((prev) => ({ ...prev, page })), 
              }}
            />
          </div>
        ),
      },
    
     
    
    ];


  return (
    <>
      <div className="">
        {/* <Form.Item className="text-center submit-btn">
          <Space>
            <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
              <ArrowLeftOutlined />
            </Button>
          </Space>
        </Form.Item> */}
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Custom Service Request</h1>
          </Col>


          {/* <Col>

            <div style={{ display: "flex", gap: "1rem" }}>
              <Search
                placeholder="Search..."
                allowClear
                size="large"
                onSearch={onSearch}
                // onChange={handleSearch}
                value={filterForm?.title}
                style={{ width: "100%" }}
              />

            </div>
          </Col> */}

        </Row>
      </div>
      <div style={{ marginTop: '20px' }}>

              <Tabs
                defaultActiveKey={activeTab}
                items={items}
                onChange={handleTabChange}
              />


      </div>
    </>
  )
}






export default CustomServiceRequest